import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { motion } from 'framer-motion'
import { Award } from 'lucide-react'

export const ResultCard = ({ student, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="h-full overflow-hidden"
    >
      <Card className="relative h-full border-2 hover:border-primary transition-all hover:shadow-xl">

        {/* 🔥 Rank / Percentile Badge (Top-Left) */}
        {student.result && (
          <div className="absolute top-4 -left-9 w-1/2 md:w-2/3 xl:w-1/2 -rotate-45 text-center bg-gradient-to-br from-primary via-primary-dark to-secondary text-white text-sm font-bold py-2 shadow-md z-10">
            {student.result}
          </div>
        )}

        <CardContent className="p-5 flex flex-col items-center text-center">

          {/* Student Image */}
          <div className="relative mb-4 mt-2">
            <img
              src={student.image}
              alt={student.name}
              className="h-36 w-36 rounded-full object-cover border-4 border-primary"
            />
            <div className="absolute -bottom-2 -right-2 bg-primary text-white rounded-full p-1">
              <Award className="h-4 w-4" />
            </div>
          </div>

          {/* Name */}
          <h4 className="text-lg font-bold text-foreground">
            {student.name}
          </h4>

          {/* Exam */}
          <p className="text-sm text-muted-foreground mt-1">
            {student.exam}
          </p>

          {/* Selection */}
          <div className="mt-3 inline-block px-4 py-1.5 bg-secondary/10 text-secondary rounded-full text-sm font-semibold mb-4">
            {student.selection}
          </div>

        </CardContent>
      </Card>
    </motion.div>
  )
}
